import { FilterType } from "../../types/ApiTable/ColumnFilter";
import { ApiTableColumn } from "../../types/ApiTable/ApiTableColumn";
import TextSearch from "./Filtering/TextSearch";
import FilterTypeahead from "./Filtering/FilterTypeahead";
import FilterSelect from "./Filtering/FilterSelect";
import FilterDateRange from "./Filtering/FilterDateRange";

interface ApiTableFilterProps {
  column: ApiTableColumn;
}

const ApiTableFilter = ({ column }: ApiTableFilterProps) => {
  const renderFilter = (type: FilterType) => {
    switch (type) {
      case FilterType.TEXT:
        return <TextSearch column={column} />;
      case FilterType.TYPEAHEAD:
        return <FilterTypeahead column={column} />;
      case FilterType.SELECT:
        return <FilterSelect column={column} />;
      case FilterType.DATE_RANGE:
        return <FilterDateRange column={column} />;
    }
  };

  return <>{renderFilter(column.filter!.type)}</>;
};

export default ApiTableFilter;
